"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformBuckets = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var sdk_ui_1 = require("@gooddata/sdk-ui");
var bucketHelper_1 = require("../../../utils/bucketHelper");
var measureBucketItemsLimit = [
    {
        localIdentifier: sdk_ui_1.BucketNames.MEASURES,
        itemsLimit: 1,
    },
    {
        localIdentifier: sdk_ui_1.BucketNames.SECONDARY_MEASURES,
        itemsLimit: 1,
    },
    {
        localIdentifier: sdk_ui_1.BucketNames.TERTIARY_MEASURES,
        itemsLimit: 1,
    },
];
exports.transformBuckets = function (buckets) {
    var bucketsWithLimitedMeasures = bucketHelper_1.limitNumberOfMeasuresInBuckets(buckets, 3, true);
    var measureBuckets = bucketHelper_1.transformMeasureBuckets(measureBucketItemsLimit, bucketsWithLimitedMeasures);
    var dateItems = bucketHelper_1.getDateItems(buckets);
    var mainDateItem = bucketHelper_1.getMainDateItem(dateItems);
    var viewByBucket = {
        localIdentifier: sdk_ui_1.BucketNames.VIEW,
        items: bucketHelper_1.removeDivergentDateItems(bucketHelper_1.getAllAttributeItems(buckets), mainDateItem).slice(0, 2),
    };
    return tslib_1.__spreadArrays(measureBuckets, [viewByBucket]);
};
//# sourceMappingURL=bucketHelper.js.map